import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as ProcoreIframeHelpers from '@procore/procore-iframe-helpers';
import { ContextService } from 'src/app/services/context.service';
import { DropboxService } from 'src/app/services/dropbox.service';
import { ProcoreService } from 'src/app/services/procore.service';

@Component({
	selector: 'app-landing',
	templateUrl: './landing.component.html',
	styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
	authError = false;
	authMessage;

	constructor(
		private contextService: ContextService,
		private dropboxService: DropboxService,
		private procoreService: ProcoreService,
		private router: Router,
		private route: ActivatedRoute
	) { }

	/**
	 * This is the initial component that gets loaded when the page loads.  This component
	 * is responsible for setting the context of the user and the side-panel.
	 * 
	 * The following occurs within this component
	 * 
	 * 1. Load the query parameters to determine if the user is
	 * 		- A. initially loading the side-panel
	 * 		- B. just authenticated against Dropbox Sign and being redirected back to the app
	 * 		- C. just accepted the Procore auth popup
	 * 	    - D. just launched a new signature request in a new tab
	 * 2. 
	 */

	// 1. https://cool-cat-cd2045.netlify.app					INITIAL SIDE-PANEL LOAD
	// 2. https://cool-cat-cd2045.netlify.app?code=123			POST PROCORE AUTH
	// 3. https://cool-cat-cd2045.netlify.app?code=123&state=	...
	// 4. 

	ngOnInit() {
		this.loadQueryParams();
	}

	loadQueryParams() {
		this.contextService.procoreIsSandbox = document.referrer.indexOf('sandbox') > -1 || document.referrer.indexOf('procore-analyzer.shakeit.ai') > -1;
		this.route.queryParams
			.subscribe({
				next: (params) => {
					if (params['code'] && params['state']) {
						// If there is a code and state, the user just signed into Dropbox and was redirected back to the app
						console.log('PA - DROPBOX AUTHENTICATED: ' + params['code']);
						this.dropboxService.createUserAuth(params['code'], params['state']).subscribe((result) => {
							this.authMessage = result;
						});
					} else if (params['code']) {
						// If there is only a code, the user just accepted the Procore auth popup
						console.log('PA - PROCORE AUTHENTICATED: ' + params['code']);
						this.contextService.procoreAuthCode = params['code'];

						const context = ProcoreIframeHelpers.initialize();
						context.authentication.notifySuccess({ code: this.contextService.procoreAuthCode });

						this.loadSidepanelContext();
					} else {
						// Initial page load
						console.log('PA - ******************************');
						console.log('PA - PROCORE ANALYZER');
						console.log('PA - ******************************');
						console.log('PA');
						this.procoreAuth();
					}
				}
			});
	}

	procoreAuth() {
		let url = '';
		let redirectUrl = '';
		if (this.contextService.procoreIsSandbox) {
			console.log('PA - AUTHENTICATE PROCORE: SANDBOX');
			redirectUrl = 'https://procore-analyzer.shakeit.ai';
			//redirectUrl = 'https://eclectic-starlight-444f6c.netlify.app';
			url = 'https://sandbox.procore.com/oauth/authorize?response_type=code&client_id=bACmEGC8tjVkh0TGD2JXOk4AdfaD-ssGqAVMcpjRAt0&redirect_uri=' + redirectUrl;
		} else {
			console.log('PA - AUTHENTICATE PROCORE: PRODUCTION');
			redirectUrl = 'https://procore-analyzer.shakeit.ai';
			//redirectUrl = 'https://eclectic-starlight-444f6c.netlify.app';
			url = 'https://login.procore.com/oauth/authorize?response_type=code&client_id=bACmEGC8tjVkh0TGD2JXOk4AdfaD-ssGqAVMcpjRAt0&redirect_uri=' + redirectUrl;
		}

		const context = ProcoreIframeHelpers.initialize();
		const _this = this;

		context.authentication.authenticate({
			url: url,
			onSuccess: function (payload) {
				window.location.href = redirectUrl + '?code=' + payload.code;
			},
			onFailure: function (error) {
				console.log('DS - PROCORE AUTH FAILED: error');
				_this.authError = true;
			}
		});
	}

	// At this point we have the code only
	loadSidepanelContext() {
		window.addEventListener('message', (event) => {
			if (event.data.context) {
				this.contextService.procoreContextObject = event.data;
				console.log('PA - SET SIDE-PANEL CONTEXT: ');
				console.log(this.contextService.procoreContextObject);

				this.getUserInfo();
			}
		});

		window.parent.postMessage({ type: 'initialize' }, '*');
	}

	getUserInfo() {
		this.procoreService.getUserInfo(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreAuthCode, this.contextService.procoreIsSandbox)
			.subscribe({
				next: (userInfo: any) => {
					this.contextService.procoreUserInfo = userInfo;
					console.log('PA - SET USER INFO:');
					console.log(this.contextService.procoreUserInfo);

					this.router.navigate(['/core']);
				},
				error: (err: any) => {
					console.log('PA - SET USER INFO ERROR:');
					console.log(err);
					// if (err.status == 504) {
					// this.getUserInfo();
					// }
				}
			});
	}
}
